module.exports = __webpack_public_path__ + "img/start_rocket.a3487e55.png";